export default (
  { activityType, toggled, message },
  { mediaQuery, rhythm, colors, radiuses, scale, transitions }
) => ({
  root: {
    position: 'relative',
    display: 'flex',
    fontSize: scale(-1),
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    padding: rhythm(1),
    background: colors.light,
    color: colors.dark,
    border: `thin solid ${colors.shade}`,
    borderRadius: rhythm(radiuses.medium),
    marginBottom: rhythm(0.5),
    textAlign: 'left'
  },
  icon: {
    position: 'relative',
    width: rhythm(1.25),
    height: rhythm(1.25),
    flex: `0 0 ${rhythm(1.25)}`,
    backgroundColor: colors.shade,
    borderRadius: '50%',
    color: colors.light,
    marginRight: rhythm(0.75),
    svg: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    [mediaQuery('sm', 'max-width')]: {
      display: 'none'
    }
  },
  content: {
    flex: 1,
    marginTop: '0.333rem'
  },
  source: {
    float: 'right',
    marginLeft: '0.5rem'
  },
  details: {
    fontSize: scale(-0.5),
    fontWeight: 'normal'
  },
  heading: {
    display: 'block',
    paddingRight: rhythm(4)
  },
  message: {
    position: 'relative',
    marginTop: rhythm(0.333),
    overflow: 'hidden',
    maxHeight: toggled ? '100vh' : '4.5em',
    transition: transitions.easeOut,
    cursor: (message && message.length > 75 && !toggled) ? 'pointer' : 'default',
    lineHeight: '1.5em',
    '&:before': {
      content: '""',
      opacity: toggled ? 0 : 1,
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      pointerEvents: 'none',
      background: `linear-gradient(transparent 1.5em, ${colors.light})`
    }
  },
  image: {
    display: 'block',
    width: '100%',
    marginTop: rhythm(0.333)
  },
  video: {
    marginTop: rhythm(0.333)
  },
  date: {
    color: colors.primary,
    marginTop: '0.375rem',
    marginLeft: rhythm(0.75),
    fontSize: scale(-2),
    textAlign: 'right',
    flex: '1 1 100%',
    [mediaQuery('sm')]: {
      flex: '0 0 auto',
      ...(activityType === 'post' && {
        position: 'absolute',
        top: 0,
        right: 0,
        padding: rhythm(1)
      })
    }
  },
  actions: {
    marginTop: rhythm(0.5)
  },
  reply: {
    display: 'inline-block',
    marginTop: rhythm(0.5),
    padding: rhythm([0.5, 1]),
    backgroundColor: colors.paleGrey,
    borderRadius: rhythm([0, 1, 1])
  }
})
